import { DlgTitleWithCloseBtn } from 'ctls/modal/DlgTitleWithCloseBtn';
import { Modal, ModalWrap } from 'ctls/modal/Modal';
import { DOC_TYPE } from 'definitions/DocType';
import { usePromise } from 'hooks/usePromise';
import { useRefComponent } from 'hooks/useRefComponent';
import { tc } from 'language/i18nkey';
import { CancelBtn } from 'pages/fb/pop_fb_create/CancelBtn';
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import styled from 'styled-components';
import { IfDocSrchEfctReq, IfDocSrchRes } from '../models/IfDocSrch';
import { DocList } from './DocList';
import { DocSelInput } from './DocSelInput';
import { useApiDocSrch } from './useApiDocSrch';

/**
 * 문서 그룹 설저.
 * 모바일, 데스크톱 팝업 레이아웃 다르게.
 */

type ShowProps = {
  lang: string;
  docTypes?: DOC_TYPE[];
  title?: string;
};

type Props = {
  show(p: ShowProps): Promise<IfDocSrchRes | null>;
};
export const PopDocSel = forwardRef<Props, {}>((props, ref) => {
  const [visible, setVisible] = useState(false);
  const promise = usePromise<{}, { cmd?: string }>();

  const [title, setTitle] = useState<string>('');

  useImperativeHandle(ref, () => ({
    show: (p: ShowProps) => {
      return new Promise((resolve, reject) => {
        promise.current = { resolve, reject };
        setInput('');
        setSel(null);
        setReq({ ...req, lang: p.lang, docTypes: p.docTypes || [] });
        setVisible(true);
        setTitle(p.title || tc('i18n_doc_grp_sel_title'));
      });
    },
  }));

  const handleClose = () => {
    setVisible(false);
    promise.current.reject({ cmd: 'close' });
  };

  const handleSelect = (item: IfDocSrchRes) => {
    promise.current.resolve(item);
    setVisible(false);
  };

  const [req, setReq] = useState<IfDocSrchEfctReq>({ keywords: [], docTypes: [], lang: '' });

  const { data, isLoading } = useApiDocSrch(req);
  const [sel, setSel] = useState<IfDocSrchRes | null>(null);

  const [input, setInput] = useState('');

  useEffect(() => {
    const keywords = (input || '')
      .split(' ')
      .filter((item) => item.length > 0)
      .map((item) => item.trim());
    setReq({ ...req, keywords });
  }, [input, setReq]);

  if (!visible) return null;

  return (
    <Modal onClick={(e) => e.stopPropagation()}>
      <Body>
        <DlgTitleWithCloseBtn title={title} onClose={handleClose} />
        <Cnts>
          <Guide>{tc('i18n_doc_grp_sel_desc')}</Guide>
          <DocSelInput value={input} onChangeInput={setInput} />
          <DocList
            list={isLoading ? [] : data}
            onSelect={(item) => {
              setSel(item);
              handleSelect(item);
            }}
            selId={sel?.id}
          />
        </Cnts>
        <Bottom>
          <CancelBtn onClick={handleClose} style={{ width: '100%' }} />
        </Bottom>
      </Body>
    </Modal>
  );
});

PopDocSel.displayName = 'PopDocSel';

export const usePopDocSel = () => useRefComponent<Props>(PopDocSel);

const Bottom = styled.div`
  padding: 0 3.2rem 2.3rem 3.2rem;
  text-align: center;
`;

const Guide = styled.div`
  font-size: 1.4rem;
  font-weight: 400;
  color: #2a2c2f;
  padding: 1.1rem 0;
`;

const Cnts = styled.div`
  padding: 0 3.2rem 2.3rem 3.2rem;
  display: flex;
  height: 1px;
  flex-grow: 1;
  gap: 1.6rem;
  overflow-y: auto;
  flex-direction: column;
`;

const Body = styled(ModalWrap)`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 54rem;
  max-width: 45rem;
  min-height: 64rem;
`;
